module.exports = __webpack_public_path__ + "img/lock.8838747d.svg";